import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import clsx from "clsx"
import MdTransformer from "~components/markdown-transformer/markdown-transformer"
import * as styles from "./aside.module.css"

const Aside = ({ type, title, children }) => {
  const [expanded, setExpanded] = useState(false)
  const [transformedChildren, setTransformedChildren] = useState(children)
  const expandable = Boolean(title)

  const expand = () => {
    if (expandable) {
      setExpanded(!expanded)
    }
  }

  // Transform relative links to include /documentation prefix (only in preview/production)
  useEffect(() => {
    const transformLinks = (content) => {
      if (typeof content === "string") {
        return content.replace(/\]\(\/([^)]+)\)/g, (match, path) => {
          // Check if we're in an environment that uses /documentation prefix
          if (window.location.pathname.startsWith("/documentation")) {
            return `](/documentation/${path})`
          }
          return match
        })
      }
      if (Array.isArray(content)) {
        return content.map(transformLinks)
      }
      return content
    }

    setTransformedChildren(transformLinks(children))
  }, [children])

  return (
    <div
      className={clsx(styles.aside, {
        [styles.hint]: type === "hint",
        [styles.warning]: type === "warn" || type === "warning",
        [styles.important]: type === "important",
        [styles.note]: type === "note",
        [styles.expandable]: expandable,
      })}
    >
      <div>
        {expandable && !expanded ? (
          <p>
            {title}{" "}
            <span className={styles.expander} onClick={expand}>
              Learn more...
            </span>
          </p>
        ) : (
          <MdTransformer>{transformedChildren}</MdTransformer>
        )}
      </div>
    </div>
  )
}

Aside.defaultProps = {
  type: "hint",
}

Aside.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
}

export default Aside
